"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Checkmark = function Checkmark(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    d: "M7.52 11.642l3.06 4.382 6.547-9.378a.625.625 0 01.953-.087c.218.229.24.58.054.835l-6.918 9.91a.776.776 0 01-1.272 0l-3.43-4.914a.652.652 0 01.054-.835.625.625 0 01.953.087z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(Checkmark);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Checkmark, "Checkmark", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Checkmark.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Checkmark.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9DaGVja21hcmsudHN4Il0sIm5hbWVzIjpbIkNoZWNrbWFyayIsInByb3BzIiwicmVmIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7Ozs7QUFFQSxJQUFNQSxTQUF5RSxHQUFHLFNBQTVFQSxTQUE0RSxDQUFDQyxLQUFELEVBQVFDLEdBQVIsRUFBZ0I7QUFDaEcsU0FDRTtBQUFLLElBQUEsS0FBSyxFQUFFLEVBQVo7QUFBZ0IsSUFBQSxNQUFNLEVBQUUsRUFBeEI7QUFBNEIsSUFBQSxPQUFPLEVBQUM7QUFBcEMsS0FBb0RELEtBQXBEO0FBQTJELElBQUEsR0FBRyxFQUFFQztBQUFoRSxNQUNFO0FBQ0UsSUFBQSxDQUFDLEVBQUMsOEtBREo7QUFFRSxJQUFBLElBQUksRUFBQztBQUZQLElBREYsQ0FERjtBQVFELENBVEQ7O2VBV2UsdUJBQVdGLFNBQVgsQzs7Ozs7Ozs7Ozs7OzswQkFYVEEsUyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBmb3J3YXJkUmVmLCBSZWZGb3J3YXJkaW5nQ29tcG9uZW50LCBTVkdQcm9wcyB9IGZyb20gJ3JlYWN0JztcblxuY29uc3QgQ2hlY2ttYXJrOiBSZWZGb3J3YXJkaW5nQ29tcG9uZW50PFNWR1NWR0VsZW1lbnQsIFNWR1Byb3BzPFNWR1NWR0VsZW1lbnQ+PiA9IChwcm9wcywgcmVmKSA9PiB7XG4gIHJldHVybiAoXG4gICAgPHN2ZyB3aWR0aD17MjR9IGhlaWdodD17MjR9IHZpZXdCb3g9XCIwIDAgMjQgMjRcIiB7Li4ucHJvcHN9IHJlZj17cmVmfT5cbiAgICAgIDxwYXRoXG4gICAgICAgIGQ9XCJNNy41MiAxMS42NDJsMy4wNiA0LjM4MiA2LjU0Ny05LjM3OGEuNjI1LjYyNSAwIDAxLjk1My0uMDg3Yy4yMTguMjI5LjI0LjU4LjA1NC44MzVsLTYuOTE4IDkuOTFhLjc3Ni43NzYgMCAwMS0xLjI3MiAwbC0zLjQzLTQuOTE0YS42NTIuNjUyIDAgMDEuMDU0LS44MzUuNjI1LjYyNSAwIDAxLjk1My4wODd6XCJcbiAgICAgICAgZmlsbD1cImN1cnJlbnRDb2xvclwiXG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgZm9yd2FyZFJlZihDaGVja21hcmspO1xuIl19